import React from "react";
import { CACHE_CONTROL } from "@search-app/config";
import BasePage from "../../components/BasePage";
import { jsx as ___EmotionJSX } from "@emotion/react";

var BrandPage = function BrandPage(props) {
  return ___EmotionJSX(BasePage, props);
};

var REDIRECTS_MAP = [{
  from: "/brand/apple",
  to: "/apple"
}, {
  from: "/brand/go-pro",
  to: "/brand/gopro"
}, {
  from: "/brand/dyson",
  to: "/dyson"
}];
/*
 * This is a workaround for the fact that we can't use Next.js rewrites
 */

BrandPage.getInitialProps = function (_ref) {
  var req = _ref.req,
      res = _ref.res;
  var host = (req === null || req === void 0 ? void 0 : req.headers["host"]) || (req === null || req === void 0 ? void 0 : req.headers["x-forwarded-host"]);
  console.info("Brand SSR for", host, req === null || req === void 0 ? void 0 : req.url);

  if (res && host) {
    var matchedRedirect = REDIRECTS_MAP.find(function (val) {
      var _req$url;

      return req === null || req === void 0 ? void 0 : (_req$url = req.url) === null || _req$url === void 0 ? void 0 : _req$url.includes(val.from);
    });

    if (matchedRedirect) {
      console.info({
        "Cache-Control": CACHE_CONTROL,
        Location: "//".concat(host).concat(matchedRedirect.to)
      });
      res.writeHead(301, {
        "Cache-Control": CACHE_CONTROL,
        Location: "//".concat(host).concat(matchedRedirect.to)
      });
      res.end();
    }
  }

  return {
    host: "unknown"
  };
};

export default BrandPage;